<script lang="ts" setup>
import { ElMessage, type FormInstance, type FormRules } from 'element-plus';
import useUserStore from '@/store/user.store';
import { $t } from '@/i18n';
import { validatePasswordRule } from '@/utils/form/vaildatorForRules'; // 密码验证规则

defineOptions({
  name: 'ChangePwdDialog'
});
const dialogVisible = defineModel<boolean>('isShowPwdDialog', {
  required: true
});
const scene = defineModel<number>('scene', { required: true });

const userStore = useUserStore();
const formRef = ref<FormInstance>();
const form = ref({
  password: '',
  currentPassword: ''
});

const rules: FormRules = {
  password: [
    {
      required: true,
      trigger: 'blur',
      message:
        $t('default.DefaultIndex.ChangePassword.Warning') +
        $t('default.DefaultIndex.ChangePassword.NewPassword')
    },
    {
      validator: validatePasswordRule,
      trigger: 'blur',
      message: $t('default.DefaultIndex.ChangePassword.PasswordFormatError')
    }
  ],
  currentPassword: [
    {
      required: true,
      trigger: 'blur',
      message:
        $t('default.DefaultIndex.ChangePassword.Warning') +
        $t('default.DefaultIndex.ChangePassword.OldPassword')
    },
    {
      validator: validatePasswordRule,
      trigger: 'blur',
      message: $t('default.DefaultIndex.ChangePassword.PasswordFormatError')
    }
  ]
};
const loading = ref(false);

const handleSubmit = async () => {
  const valid = await formRef.value?.validate();

  if (!valid) return;

  if (form.value.password === form.value.currentPassword) {
    ElMessage.error($t('api.message.5003'));

    return;
  }

  loading.value = true;
  try {
    const { data } = await userStore.changePassword({
      password: form.value.password,
      currentPassword: form.value.currentPassword,
      scene: Number(scene.value)
    });

    if (userStore?.passwordExpired && Number(scene.value) === 2) {
      userStore.setPasswordExpired(false);
    }

    if (data.code !== 0) {
      ElMessage.error(data.msg);
    } else {
      ElMessage.success(data.msg);
      await userStore.logout();
    }

    dialogVisible.value = false;
  } catch (error) {
    if (error instanceof Error) {
      ElMessage.error(error.message);
    } else {
      ElMessage.error(String(error));
    }
  } finally {
    loading.value = false;
  }
};

</script>

<template>
  <el-dialog
    v-model="dialogVisible"
    :title="$t('default.DefaultIndex.002325-4')"
    width="500px"
    destroy-on-close
  >
    <el-form
      ref="formRef"
      :model="form"
      :rules="rules"
      :validate-on-rule-change="false"
    >
      <el-row>
        <el-col :span="24" class="tw-pt-[14px]">
          <el-form-item
            label-width="120px"
            :label="$t('default.DefaultIndex.ChangePassword.NewPassword')"
            prop="password"
          >
            <ElInput
              v-model.trim="form.password"
              :placeholder="$t('default.DefaultIndex.ChangePassword.NewPassword')"
              type="password"
              autocomplete="off"
              show-password
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="tw-pt-[14px]">
          <el-form-item
            label-width="120px"
            :label="$t('default.DefaultIndex.ChangePassword.OldPassword')"
            prop="currentPassword"
          >
            <ElInput
              v-model.trim="form.currentPassword"
              :placeholder="$t('default.DefaultIndex.ChangePassword.OldPassword')"
              type="password"
              autocomplete="off"
              show-password
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-button @click="dialogVisible = false">
        {{ $t('default.DefaultIndex.002325-9') }}
      </el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit">
        {{ $t('default.DefaultIndex.002325-7') }}
      </el-button>
    </template>
  </el-dialog>
</template>